import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, X, Check } from 'lucide-react';
const results = [{
  before: 'Scrolleaba 5 horas al día sin poder parar',
  after: 'Construí una rutina de trabajo de 4 horas sin distracciones'
}, {
  before: 'Empezaba todo y no terminaba nada',
  after: 'Terminé mi primer proyecto y lo moneticé en 60 días'
}, {
  before: 'Sabía lo que tenía que hacer pero no lo hacía',
  after: 'La disciplina se volvió mi identidad, no un esfuerzo'
}];
export function ResultsSection() {
  return <section className="py-24 bg-[#080808] relative overflow-hidden" data-id="element-341">
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#C9A84C]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-342" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-343">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-344">
          <span className="text-[#C9A84C] tracking-[0.2em] text-xs font-bold uppercase mb-3 block" data-id="element-345">
            Transformaciones reales
          </span>
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white" data-id="element-346">
            LO QUE CAMBIA EN VOS
          </h2>
          <div className="w-12 h-[1px] bg-[#C9A84C] mx-auto mt-4" data-id="element-347" />
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-348">
          {results.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-[#111] border border-white/5 rounded-sm overflow-hidden group hover:border-[#C9A84C]/30 transition-colors duration-300" data-id="element-349">
              {/* Before Section */}
              <div className="p-6 bg-red-950/10 border-b border-white/5 relative" data-id="element-350">
                <div className="flex items-center gap-2 mb-3" data-id="element-351">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-352">
                    <X className="w-3 h-3 text-red-500" data-id="element-353" />
                  </div>
                  <span className="text-red-500 text-xs font-bold tracking-widest uppercase" data-id="element-354">
                    ANTES
                  </span>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed italic" data-id="element-355">
                  "{item.before}"
                </p>
              </div>

              {/* Connector */}
              <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent relative" data-id="element-356">
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-[#111] border border-[#C9A84C]/30 flex items-center justify-center z-10" data-id="element-357">
                  <ArrowRight className="w-3 h-3 text-[#C9A84C] rotate-90 md:rotate-0" data-id="element-358" />
                </div>
              </div>

              {/* After Section */}
              <div className="p-6 bg-[#C9A84C]/5 relative h-full" data-id="element-359">
                <div className="flex items-center gap-2 mb-3" data-id="element-360">
                  <div className="w-5 h-5 rounded-full bg-[#C9A84C]/20 flex items-center justify-center" data-id="element-361">
                    <Check className="w-3 h-3 text-[#C9A84C]" data-id="element-362" />
                  </div>
                  <span className="text-[#C9A84C] text-xs font-bold tracking-widest uppercase" data-id="element-363">
                    DESPUÉS
                  </span>
                </div>
                <p className="text-white text-base font-medium leading-relaxed" data-id="element-364">
                  "{item.after}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}